module.exports = __webpack_public_path__ + "static/media/hets-logo-long.2acabc3a.png";